import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpService } from './http.service'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { ApiReducers } from './api.root.state'

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('api', ApiReducers), EffectsModule.forFeature([])],
  providers: [HttpService, provideHttpClient(withInterceptorsFromDi())]
})
export class ApiModule {}
